<template>
  <div>
    <a-descriptions title="配置信息" :column="2">
      <a-descriptions-item label="CPE型号">
        {{ data.cpe_model_name }}
      </a-descriptions-item>

      <a-descriptions-item label="通信制式">
        {{ data.common_mode }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  name: 'AgentPurchaseItemCpeConfigureInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
